<button (click)="onPO2ChartClick()" class="graph mat-elevation-z2">
  <div id="po2-chart" class="plotly-graph" [class]="getGraphClass()"></div>
  @if (!getShowGraphs()) {
    <div>Create dive segements to populate graphs</div>
  }
</button>
